import { render, staticRenderFns } from "./OrgnzDetailProfile.vue?vue&type=template&id=132871f7&"
import script from "./OrgnzDetailProfile.vue?vue&type=script&lang=js&"
export * from "./OrgnzDetailProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports